import Immutable from "immutable";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { useClientState } from "../../../../common/useClientState";
import { SearchCriterion } from "../common/SearchCriterion";
import CheckboxesDropdown, { CheckboxesDropdownProps } from "./CheckboxesDropdown";
import {
	checkboxesChoicesType,
	criterionToClearType,
	requiredRolesType,
} from "../../../../common/types/search/search";
import { visibilitySelectorType } from "../../../../common/types/common";

export const CHECKBOX_CRITERION_INITIAL_STATE = Immutable.List();

interface CheckboxCriterionProps extends CheckboxesDropdownProps {
	choices: checkboxesChoicesType;
	criterionKey: string;
	label: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	saveToClientState?: boolean;
	isInitiallyOpened?: boolean;
	criterionToClear?: criterionToClearType;
	visibilitySelector?: visibilitySelectorType;
}

export function CheckboxCriterion({
	choices,
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	visibilitySelector,
	saveToClientState,
	isInitiallyOpened = false,
	criterionToClear,
	...props
}: CheckboxCriterionProps) {
	const {
		currentInput,
		onCriterionInputChange,
		onInputChange,
		onClearInput,
	} = useFormComponentState(criterionKey, CHECKBOX_CRITERION_INITIAL_STATE);
	const { onChangeClientState } = useClientState(
		criterionKey,
		saveToClientState,
	);

	const handleInputChange = (newInput) => {
		onInputChange(newInput);

		if (criterionToClear) {
			onCriterionInputChange(
				criterionToClear.key,
				criterionToClear.value,
			);
		}
	};

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
			visibilitySelector={visibilitySelector}
		>
			<CheckboxesDropdown
				label={label}
				choices={choices}
				criterionKey={criterionKey}
				currentInput={currentInput}
				onInputChange={handleInputChange}
				onClearInput={onClearInput}
				onChangeClientState={onChangeClientState}
				prefix={prefix}
				quickSearch={quickSearch}
				isInitiallyOpened={isInitiallyOpened}
				{...props}
			/>
		</SearchCriterion>
	);
}
